import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {OmsDetectorDataEntry} from "../../models/oms-detector-data-entry";
import {OmsValidateKeyDataResponse} from "../../models/responses/oms-validate-key-data-response";
import {OmsDownloadHistoryResponse} from "../../models/responses/oms-download-history-response";

@Injectable({
  providedIn: 'root'
})
export abstract class OmsKeyDownloadService {
  public abstract validateKeyData(entries: OmsDetectorDataEntry[]): Observable<OmsValidateKeyDataResponse>
  public abstract requestHistoryEntriesByOrderNumber(orderNumber: string): Observable<OmsDownloadHistoryResponse>
  public abstract requestHistoryEntriesBySerialNumbers(serialNumbers: string[]): Observable<OmsDownloadHistoryResponse>
  public abstract downloadCsvFileByOrderNumber(friendlyCaptchaResponse: string, orderNumber: string): void
  public abstract downloadCsvFileBySerialNumbers(friendlyCaptchaResponse: string, serialNumbers: string[]): void
}
